import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { baseApiUrl } from "../service/base-url";
import classNames from '../utils'
import { useSelector } from "react-redux";

const WorkInner = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const language = useSelector((state) => state.language.language);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(`${baseApiUrl}/products/${id}`, {
          headers: { 'Content-Type': 'application/json', 'x-localization': language }
          
        })
        const dataRes = response.data
        if (dataRes) {
          setProduct(dataRes.data)
        }
      } catch (error) {
        toast.error('Please try again.')
        console.error('Error:', error)
      }
    }

    fetchProduct();
  }, [id,language]);


  if (!product) return <p>Loading...</p>;


  console.log(product,'product');
  
  return (
        <div
          className='bg-white sm:px-8 flex justify-center'>
              <div className="w-full mb-12 mt-12 justify-around items-center flex-wrap flex-col lg:flex-row flex gap-x-3">
                  <div className="p-4 mt-8 flex flex-col md:flex-row justify-arround gap-x-20 w-[100%] lg:w-[100%]">
                    <img className="w-full max-w-[330px] 2xl:max-w-[300px] object-contain md:object-cover max-h-[300px] min-h-[280px] md:min-h-[300px]" alt="png" src={product?.images[0]?.url}/>
                    <div className="mt-3">
                      <p className="text-darkBg font-customFont font-light text-[22px] two-line-truncate max-w-[428px]">{product.title}</p>
                      <p className="text-darkBg font-customFont font-light text-lg"> #{product.code}</p>
                        <p
                          className={classNames(
                            'myHtml text-xl text-darkBg mt-6 leading-10 font-customFamily font-normal max-w-[325px] md:max-w-[610px] min-w-[325px] md:min-w-[510px]'
                          )}
                          dangerouslySetInnerHTML={{ __html: product?.description || '' }}
                        />  
                      {product.is_actual ? <p className="text-green-600 font-customFont font-light text-lg">Available</p> :
                      <p className="text-red-700  font-customFont font-light text-[22px]">Not available</p> }                    </div>
                  </div>
                </div>
          </div>
        );
};

export default WorkInner;
